<adapt-feature-guidance [configItem]="configItem">
    <p>{{ configItem?.supportText }}</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem">
    <div class="d-flex flex-column gap-2">
        @for (link of ownerTeamLinks; track link.team.teamId) {
            <div>
                <a *adaptIfAuthorised="CanConfigureTeam; entity: link.team"
                   adaptButton="configureLink"
                   [routerLink]="link.route.path"
                   [queryParams]="link.route.queryParams"
                   data-test="configure-owners-team-vision">Configure {{link.team.name}} team vision</a>
            </div>
        }
    </div>
</adapt-feature-configuration>
